import React, { createContext, useContext, useEffect, useState } from 'react';
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseApiKey = process.env.REACT_APP_SUPABASE_API_KEY;

const SupabaseContext = createContext({ supabase: null });

export default function SupabaseProvider({ children }) {
    const [supabase, setSupabase] = useState(null);

    useEffect(() => {
        if (!supabaseUrl || !supabaseApiKey) {
            console.info('Supabase URL or API key is missing');
            return;
        }

        const supabaseClient = createClient(supabaseUrl, supabaseApiKey);
        setSupabase(supabaseClient);
    }, []);

    return (
        <SupabaseContext.Provider value={{ supabase }}>
            {children}
        </SupabaseContext.Provider>
    );
}

export const useSupabase = () => useContext(SupabaseContext);
